import { render } from "./CardSkeletonLoader.vue?vue&type=template&id=9a793470"
import script from "./CardSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./CardSkeletonLoader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__